import {Map} from 'maplibre-gl';
import { Protocol } from 'pmtiles';

export interface MapContent {

  load(map: Map, protocol: Protocol, zoomToFeatures: boolean): void;
  unload(): void;
}

export abstract class MapContentBase {

  protected map: Map = null;
  protected protocol: Protocol = null;
  protected firstSymbolLayerId: string;

  protected getFirstSymbolLayerId(): string {
    const layers = this.map.getStyle().layers;
    // Find the index of the first symbol layer in the map style
    let firstSymbolId;
    for (const item of layers) {
      if (item.type === 'symbol') {
        firstSymbolId = item.id;
        break;
      }
    }
    return firstSymbolId;
  }
}
